import React, { useEffect, useState } from "react";
import { formatTextWithLineBreaks } from "../../utils/handler";
import ModalBox from "../../Components/modals/ModalBox";
import ViewRelationshipDetail from "./DetailsContent/ViewRelationshipDetail";
import AddPermission from "./DetailsContent/AddPermission";
import AccountPermission from "./DetailsContent/AccountPermission";

export default function DetailsModal({
  showModal,
  closeModal,
  proxyKey,
  proxyType,
  editFn,
  deleteFn,
  listingFn,
  isProfile=false
}) {
  const [isLoading, setIsLoading] = useState({ modal: true, content: true });
  const [viewType, setViewType] = useState("");
  
  const handleViewChange = (view) => {
    setIsLoading({ modal: true, content: true });
    setViewType(view);
  }
  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize={viewType==='addPermission' ? 'md' : 'lg'}
      hasData={true}
    >
      {(() => {
        switch (viewType) {
          case "acctPermission":
            return (
              <AccountPermission
                proxyKey={proxyKey}
                changeView={() => handleViewChange("addPermission")}
                handleBack={() => handleViewChange("")}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            );
          case "addPermission":
            return (

              <AddPermission
                proxyKey={proxyKey}
                handleBack={() => handleViewChange("acctPermission")}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            );
          default:
            return (
              <ViewRelationshipDetail
                proxyKey={proxyKey}
                proxyType={proxyType}
                changeView={() => handleViewChange("acctPermission")}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                editFn={editFn}
                deleteFn={deleteFn}
                closeModal={closeModal}
                listingFn={listingFn}
                isProfile={isProfile}
              />
            );
        }
      })()}
    </ModalBox>
  );
}

export function ModalHeader(params) {
  return (
    <div className="text-center position-relative d-flex justify-content-between">

      <h3 className="modal-title mb-0 mt-0">{params.title}</h3>
      {params.handleBack && (
        <a onClick={params.handleBack} style={{cursor: 'pointer', fontSize: '13px'}} className="m-0 d-flex align-items-center cursor-pointer"><span className="material-symbols-outlined " > keyboard_arrow_left </span>Back</a>
      )}
      {params.menuarray?.length > 0 && (
        <div className="rlshp-settings">
          <div className="btn-group option-btn">
            <a
              href="javascript:void(0)"
              className="btn dropdown-toggle"
              data-bs-toggle="dropdown"
              data-bs-display="static"
              aria-expanded="false"
            >
              <i className="fa-solid fa-gear"></i>
            </a>
            <ul className="dropdown-menu dropdown-menu-end">
              {params.menuarray.map((menu, i) => (
                <li key={i} onClick={() => params.triggerMenu(menu.type)}>
                  <a className="dropdown-item" href="javascript:void(0)">
                    {menu.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export function ModalContentWithData(params) {
  return (
    <div className="form-group mt-4 view-rltionshp">
      <div className="row align-items-start">
        <div className="col-12">
          <div className="web-card-relo px-3 py-3">
            <div className="row">
              <div className="col-lg-6">
                <div className="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap text-center">
                  <div className="profile-img">
                    <img src={params.proxydata?.image_path} />
                  </div>
                  <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                    <h3 className="mb-1">{params.proxydata?.name}</h3>
                    <small className="d-block">
                      {params.proxydata?.proxy_relation}
                    </small>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex  justify-content-end align-items-center">
                <div className="text-center text-lg-end w-100">
                  {params.proxydata?.formatted_address && (
                    <p
                      className=" mb-0"
                      dangerouslySetInnerHTML={{
                        __html: formatTextWithLineBreaks(
                          params.proxydata?.formatted_address
                        ),
                      }}
                    ></p>
                  )}
                  {params.proxydata?.phone_number && (
                    <p className="mb-0">
                      {params.proxydata?.phone_number}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {params.children}
        {/* content here */}
      </div>
    </div>
  );
}
